export default __webpack_public_path__ + "static/media/compass.bf0a679d.svg";